






















































































































































































































































































































































































































import { BannersStore } from '@src/federations/sportOffer/banners/store';
import { SportOfferUIStore } from '@store/modules/ui/sportOffer/sports/sportsIndex';
import {
    useVuexStore,
    isMobileLayout,
    useVueRouter,
    useI18n,
} from '@superbet-group/web.lib.vue-utilities';
import { SelectionSourceScreen } from '@superbet-group/web.types';
import {
    computed,
    defineComponent,
    onBeforeUnmount,
    onMounted,
    reactive,
    Ref,
    ref,
    watch,
} from '@vue/composition-api';
import { HomeEventCardSource } from '@app/enums';
import QuickLinksContainer from '@app/modules/shared/banners/QuickLinksContainer.vue';
import { SportOfferDataStore } from '@store/modules/data/sportOffer';
import SportOfferCarousel from '@modules/sportOffer/sharedSubmodules/SportOfferCarousel.vue';
import HomeInPlay from '@modules/sportOffer/sharedSubmodules/HomeInPlay.vue';
import { SuperOfferKeys } from '@core/models/offer/enums';
import { Link } from '@src/app/router/constants/Link';
import HotTournamentsCarousel from '@modules/sportOffer/hotTournaments/HotTournamentsCarousel.vue';
import MEBBBanner from '@src/federations/sportOffer/bet-builder/multi-event/components/MEBBBanner.vue';
import PromotionsBannerContainer from '@shared/banners/PromotionsBannerContainer.vue';
import { Product } from '@app/router/products/Product';
import modalCodes from '@store/modules/ui/shared/modal/modalCodes';
import modalStore from '@store/modules/ui/shared/modal/modalIndex';

import { getFederationComponent } from '@src/federations/getFederationComponent';
import { AuthenticationStore } from '@store/modules/data/authentication/authenticationIndex';
import { shellLocalConfig } from '@src/config/shell/localConfig';
import { sortBy } from '@core/utils/sort/sortBy';
import { featureFlagService } from '@superbet-group/web.lib.flags';
import { TimeFilterSlug } from '@store/modules/ui/shared/timeFilter/utils';
import { Unsubscribe } from '@superbet-group/web.lib.feature-toggle-service';
import { SportId } from '@core/constants';
import PopularSuperbetsCarousel from '@modules/sportOffer/popularSuperbets/PopularSuperbetsCarousel.vue';
import { isIntersectionObserverAvailable } from '@app/utils/browser/isIntersectionObserverAvailable';
import { createSendHomepageOpenedToGtm } from '@src/app/gtm/sendHomepageOpenedToGtm';
import { getLiteMode } from '@modules/layout/header/utils/metaWhitelist';
import {
    isSocialEnabled,
    isSocialAppEnabled,
} from '@socialFederation/helpers';
import PE92InlineDepositForm from '@walletFederation/src/components/PE92InlineDepositForm.vue';
import { MultiEventBetBuilderBannerLocation } from '@sportOfferFederation/bet-builder/multi-event/enums/MultiEventBetBuilderBannerLocation';
import { isBelgium } from '@modules/layout/utils/isCountry';
import { useShowSuperBonusV2WelcomeModal } from '@src/app/modals/modals/super-bonus/useShowSuperBonusV2WelcomeModal';
import { updateCacheEventBettorNumber } from '@shared/event/composeable/eventBettorNumber';
import { SelfCleaningClientStorage } from '@core/utils/selfCleaningClientStorage/createSelfCleaningClientStorage';
import { NavigationDataStore } from '@store/modules/navigation';
import { Analytics as AnalyticsSDK } from '@superbet-group/web.analytics.sdk';
import { AccountFlagNames } from '@modules/userProfile/account/FeatureFlags';
import {
    InspirationalCopyExperimentVariant,
    PeerUrgencyExperimentVariant,
} from '@core/models/user/flags';
import { maybeOpenForgotPasswordModal } from '@src/app/router/utils';
import SeoCopyBlockWrapper from '@src/app/seo/SeoCopyBlockWrapper.vue';
import { usePE123Experiment } from '@accountFederation/utils/usePE123Experiment';
import { useGetFeatureFlag } from '@src/app/shared/featureFlags/useGetFeatureFlag';
import { BetslipStore } from '@store/modules/ui/betSlip';
import { getShellConfig } from '@src/config/shell/config';
import { transformAndDenormalizeTopPriceBoostOdds } from '@sportOfferFederation/price-boost/utils';
import {
    HomePagePriceBoostPosition,
    PriceBoostOdd,
} from '@sportOfferFederation/price-boost/types';
import { RouteName } from '@src/app/router/constants/RouteName';
import { getEventSlugFromEvent } from '@modules/eventDetailsPage/utils';
import TopPriceBoostsService from '@sportOfferFederation/price-boost/TopPriceBoostsService';
import { variantTranslationKeyHomeSectionSubtitle } from './useVariantTranslationKeyHomeSectionLabels';
import Survey from '@modules/survey/Survey.vue';
import { slugify } from '@superbet-group/web.lib.utilities';
import { SdsSkeleton } from '@superbet-group/web.lib.ui-components';
import { useSports } from '@src/app/shared/modules/sportOffer/composition/useSports';
import { BooleanExperimentsSegment } from '@superbet-group/product.analytics';
import { useSportsLayouts } from '@shared/sportsLayouts/useSportsLayouts';
import {
    HomeComponentMap,
    HomeComponent,
    HomeComponentKey,
} from '../shared/sportsLayouts/homeComponentsList';
import { SportsLayoutsPage } from '@core/services/offerPresentation/OfferPresentationService';

let observer: IntersectionObserver | null = null;

export default defineComponent({
    // eslint-disable-next-line sonarjs/cognitive-complexity
    setup() {
        const { translate } = useI18n();
        const {
            isLoading: loadingHomeContainer,
            areSportsLayoutsEnabled,
            enabledComponents,
        } = useSportsLayouts(SportsLayoutsPage.HOME) as {
            isLoading: Ref<boolean>;
            areSportsLayoutsEnabled: Ref<boolean>;
            enabledComponents: Ref<HomeComponentKey[]>
        };

        const sportOfferUiStore = useVuexStore<SportOfferUIStore>('ui/sportOffer/sports');
        const bannerStore = useVuexStore<BannersStore>('data/banners');
        const authModule = useVuexStore<AuthenticationStore>('data/authentication');
        const sportOfferDataStore = useVuexStore<SportOfferDataStore>('data/sportOffer');
        const modalModule = useVuexStore<typeof modalStore>('ui/modal');

        const arePopularSuperbetsOnHomeEnabled = ref(false);
        const showMEBBBanner = ref(false);
        const areTopTenEventsEnabled = ref(false);
        const componentRendered = reactive(getDefaultComponentStates());
        const bettorNumberCache = ref<SelfCleaningClientStorage<number, number>>();
        const sendHomepageOpenedToGtm = createSendHomepageOpenedToGtm();
        const isSuperOfferFetched = sportOfferDataStore.getter('isSuperOfferFetched');
        const subscribeToEvent = sportOfferDataStore.action('subscribeToEvent');
        const unsubscribeFromEvent = sportOfferDataStore.action('removeSubscription');
        const navigationModule = useVuexStore<NavigationDataStore>('navigation');
        const [
            socialProofDesignVariant,
            onSocialProofDesignVariantReady,
        ] = useGetFeatureFlag<PeerUrgencyExperimentVariant>(
            AccountFlagNames.whichPE124ExperimentVariant,
            PeerUrgencyExperimentVariant.None,
        );
        const title = computed(() => navigationModule.getter('routeSeoData').value?.title);
        const shellConfig = getShellConfig();
        const [
            isCasinoGamesOnHomePageExperimentEnabled,
            onIsCasinoGamesOnHomePageExperimentEnabledReady,
        ] = useGetFeatureFlag<boolean>(
            AccountFlagNames.isCasinoGamesOnHomePageExperimentEnabled,
            false,
        );
        const idOfCasinoSection = computed(() => shellConfig.remoteConfig.experiments?.idOfGamesSectionInSportsHome || 'all-games');
        const homePagePriceBoostPosition = getShellConfig().remoteConfig.generosity.homePagePriceBoostPosition;
        const isUserElegibleToChallenge = usePE123Experiment();

        const sectionSubtitleTranslationKeys = computed(() => variantTranslationKeyHomeSectionSubtitle[inspirationalCopyVariant.value]);

        onMounted(async () => {
            showSuperBonusV2WelcomeModal();

            // Await, flags are requirement to determine if we should fetch top price boosts
            await fetchPriceBoostCarouselFeatureFlag();
            await fetchPriceBoostPagesFeatureFlag();
            fetchTopPriceBoosts();
        });

        const isPriceBoostDedicatedPagesEnabled = ref(false);
        async function fetchPriceBoostPagesFeatureFlag() {
            isPriceBoostDedicatedPagesEnabled.value = await featureFlagService.getFeatureValue(
                'bex.generosity.price-boost-v-3-dedicated-pages',
                false,
            );
        }

        const isPriceBoostCarouselEnabled = ref(false);
        async function fetchPriceBoostCarouselFeatureFlag() {
            isPriceBoostCarouselEnabled.value = await featureFlagService.getFeatureValue(
                'bex.generosity.price-boost-v-3-home-section',
                false,
            );
        }

        onSocialProofDesignVariantReady((variant) => {
            if (variant === PeerUrgencyExperimentVariant.None) {
                return;
            }
            AnalyticsSDK.getInstance().log(
                'Social_Proof_Text_Shown_In_Home',
                {
                    variant,
                },
            );
        });

        onIsCasinoGamesOnHomePageExperimentEnabledReady((isEnabled) => {
            AnalyticsSDK.getInstance().log('PE_182_Casino_Section_In_Sports_Home_Variant_Activated', {
                group: isEnabled ? BooleanExperimentsSegment.B : BooleanExperimentsSegment.A,
            });
        });

        const [
            inspirationalCopyVariant,
            onInspirationalCopyVariantReady,
        ] = useGetFeatureFlag<InspirationalCopyExperimentVariant>(
            AccountFlagNames.whichInpirationalCopyVariant,
            InspirationalCopyExperimentVariant.None,
        );
        onInspirationalCopyVariantReady((variant) => {
            if (variant === InspirationalCopyExperimentVariant.None) {
                return;
            }
            AnalyticsSDK.getInstance().log(
                'PE_160_Home_Inspirational_Titles_Copy_Show',
                {
                    variant,
                },
            );
        });

        function getDefaultComponentStates() {
            const states: Record<string, boolean> = {};
            Object.keys(HomeComponent).forEach((key) => {
                states[key] = false;
            });
            return states;
        }

        if (isIntersectionObserverAvailable()) {
            initializeObserver();
        } else {
            sendHomepageOpenedToGtm();
        }

        function shouldRenderComponent(component: HomeComponentKey) {
            return observer ? componentRendered[component] : true;
        }

        function initializeObserver() {
            observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    const id = (entry.target as HTMLElement).dataset.id as HomeComponentKey;

                    sendHomepageOpenedToGtm();

                    // When leaving the viewport, unobserve as we don't need to track it anymore
                    if (!entry.isIntersecting && componentRendered[id]) {
                        observer?.unobserve(entry.target);
                        return;
                    }

                    componentRendered[id] = entry.isIntersecting;
                });
            }, {
                root: null,
                rootMargin: '0px',
                threshold: 0.05,
            });
        }

        let superbetsUnsubFn: Unsubscribe | undefined;
        let mebbUnsubFn: Unsubscribe | undefined;
        let topTenUnsubFn: Unsubscribe | undefined;

        (() => {
            superbetsUnsubFn = featureFlagService.subscribeToFeatureChanges('sports-offer.popular-superbets-on-home', (isEnabled) => {
                arePopularSuperbetsOnHomeEnabled.value = isEnabled;
            }, false);
        })();

        (() => {
            mebbUnsubFn = featureFlagService.subscribeToFeatureChanges('sports-offer.bet-builder.multi-event.feature-enabled', (isEnabled) => {
                showMEBBBanner.value = isEnabled;
            }, false);
        })();

        (() => {
            topTenUnsubFn = featureFlagService.subscribeToFeatureChanges('offer-presentation-top-10', (isEnabled) => {
                areTopTenEventsEnabled.value = isEnabled;
            }, false);
        })();

        const user = authModule.getter('user');
        const setModal = modalModule.action('setModal');

        const { showSuperBonusV2WelcomeModal } = useShowSuperBonusV2WelcomeModal(setModal);

        const surveyPageSetup = getShellConfig().remoteConfig.homepageSurveySetup;

        const fetchSuperEvents = sportOfferDataStore.action('fetchSuperEvents');
        const subscribeToEventChanges = sportOfferDataStore.action('subscribeToEventChanges');
        const subscribeToStructChanges = sportOfferDataStore.action('subscribeToStructChanges');
        const setAreSubscriptionsSet = sportOfferDataStore.action('setAreSubscriptionsSet');
        const fetchLiveEvents = sportOfferDataStore.action('fetchLiveEvents');
        fetchLiveEvents();
        fetchSuperEvents();
        subscribeToEventChanges();
        subscribeToStructChanges();
        setAreSubscriptionsSet(true);

        const promotionalEvents = sportOfferUiStore.getter('promotionalEventGroups');
        const superKvota = computed(() => promotionalEvents.value
            .find((promotion) => promotion.id === SuperOfferKeys.superCota));
        const superExtra = computed(() => promotionalEvents.value
            .find((promotion) => promotion.id === SuperOfferKeys.superExtra));

        const showPromotedEvents = shellLocalConfig.arePromotedEventsEnabled;

        watch(() => isSuperOfferFetched.value, () => {
            if (showPromotedEvents) {
                promotionalEvents.value.flatMap((promotion) => promotion.events).forEach((event) => {
                    subscribeToEvent(event.id);
                });
            }
        });

        const allEvents = sportOfferDataStore.getter('events');

        watch(allEvents, (events) => {
            bettorNumberCache.value = updateCacheEventBettorNumber(events);
        });
        const liveEvents = computed(() => {
            const liveEvents = allEvents.value
                .filter((event) => event.isOngoing() && !event.isFinished() && !event.isStopped());
            return sortBy(liveEvents, [
                'matchPromotedLiveOrder',
                ...shellLocalConfig.sportOfferSort.getEventSortRules(),
            ]);
        });

        const fetchV2QuickLinks = bannerStore.action('fetchSportQuickLinksV2');
        fetchV2QuickLinks();
        const quickLinks = bannerStore.getter('quickLinksV2');
        const fetchPromotionBannersV2 = bannerStore.action('promotionBannersV2');
        fetchPromotionBannersV2();

        const isMobile = computed(() => isMobileLayout());
        const isLoggedIn = computed(() => !!user.value);

        // When user status changes we need to fetch quick links and check their status in LaunchDarkly
        watch(user, () => {
            setTimeout(() => {
                fetchV2QuickLinks();
            }, 200);
        });

        function openLoginModal() {
            setModal({ code: modalCodes.login });
        }

        const { route, router } = useVueRouter();
        maybeOpenForgotPasswordModal(route.value);

        onBeforeUnmount(() => {
            superbetsUnsubFn?.();
            mebbUnsubFn?.();
            topTenUnsubFn?.();
            observer?.disconnect();

            if (showPromotedEvents) {
                promotionalEvents.value.flatMap((promotion) => promotion.events).forEach((event) => {
                    unsubscribeFromEvent(event.id);
                });
            }
        });

        // Top Price Boosts
        const isPriceBoostCarouselVisible = computed(() => isPriceBoostCarouselEnabled.value && homePagePriceBoostPosition);
        const shouldRenderPriceBoostCarousel = computed(() => {
            return isMobile.value
                ? isPriceBoostCarouselVisible.value
                : isPriceBoostCarouselVisible.value && priceBoostOdds.value.length > 1;
        });

        const priceBoostOdds = ref<any[]>([]);
        const fetchTopPriceBoosts = async () => {
            if (isPriceBoostCarouselVisible.value) {
                const events = await TopPriceBoostsService.getTopPriceBoosts();
                priceBoostOdds.value = await transformAndDenormalizeTopPriceBoostOdds(events);
            }
        };

        const betslipStore = useVuexStore<BetslipStore>('ui/sportOffer/betSlip');
        const toggleSelection = betslipStore.action('toggleSelection');
        const eventOddMap = betslipStore.getter('eventOddMap');

        const selectedOdds = computed(() => {
            const selected = new Set();
            priceBoostOdds.value.forEach((odd) => {
                if (eventOddMap.value[odd.eventId]) {
                    eventOddMap.value[odd.eventId].forEach((selectedOdd) => {
                        selected.add(selectedOdd);
                    });
                }
            });
            return selected;
        });

        const onPriceBoostOddClick = (odd: PriceBoostOdd) => {
            const { id: oddId, specialBetValue, uuid, eventId } = odd;
            toggleSelection({
                eventId,
                oddId,
                uuid,
                specialBetValue,
                sourceScreen: SelectionSourceScreen.HomeTopPriceBoost,
            });
        };

        const getEvent = sportOfferDataStore.action('getEvent');
        const eventsMap = sportOfferDataStore.getter('eventsMap');
        async function onPriceBoostCardClick(odd: PriceBoostOdd) {
            const event = eventsMap.value[odd.eventId!];

            if (!event) {
                await getEvent(Number(odd.eventId));
            }

            router.value.push({
                name: RouteName.Sport.OfferEvent,
                params: { eventSlug: getEventSlugFromEvent(eventsMap.value[odd.eventId!]) },
            });
        }

        const { sports } = useSports();

        function onPriceBoostSeeAllClick() {
            const footbalName = sports.value.find((s) => s.id === SportId.Football)?.name;
            router.value.push({
                name: RouteName.Sport.PriceBoost,
                params: {
                    sportSlug: slugify(footbalName!),
                },
            });
        }
        // End Top Price Boosts
        const isLiteMode = getLiteMode() === 'true';

        const componentsMap = computed(() => {
            return {
                [HomeComponent.BANNERS]: {
                    component: PromotionsBannerContainer,
                    props: {
                        banners: bannerStore.getter('promotionBannersV2').value,
                    },
                    shouldShow: !isLiteMode,
                },
                [HomeComponent.QUICK_LINKS]: {
                    component: QuickLinksContainer,
                    props: {
                        quickLinks: quickLinks.value,
                    },
                    shouldShow: !isLiteMode,
                },
                [HomeComponent.INLINE_DEPOSIT_FORM]: {
                    component: PE92InlineDepositForm,
                    props: {
                        positioning: 'homePage',
                    },
                    shouldShow: true,
                },
                [HomeComponent.ONBOARDING_CHALLENGE_TRACKER]: {
                    component: 'PE123OnboardingChallengeTracker',
                    props: {},
                    shouldShow: isLoggedIn.value && isUserElegibleToChallenge.value,
                },
                [HomeComponent.TOP_TEN]: {
                    component: SportOfferCarousel,
                    props: {
                        items: sportOfferUiStore.getter('topTenEvents').value,
                        title: translate('home.topTen.title'),
                        titleDescription: translate(sectionSubtitleTranslationKeys.value.topTen),
                        titleIcon: 'status-arrows-up',
                        areEventsFetched: sportOfferDataStore.getter('areTopTenEventsFetched').value,
                        sourceScreen: SelectionSourceScreen.HomeTopTen,
                        eventCardSource: HomeEventCardSource.Top10,
                        class: 'e2e-top-ten',
                        bettorNumberCache: bettorNumberCache.value,
                        socialProofDesignVariant: socialProofDesignVariant.value,
                    },
                    shouldShow: areTopTenEventsEnabled.value,
                },
                [HomeComponent.TOP_LIVE]: {
                    component: SportOfferCarousel,
                    props: {
                        items: sportOfferUiStore.getter('superLiveEvents').value,
                        title: translate('super live'),
                        titleDescription: translate(sectionSubtitleTranslationKeys.value.superLive),
                        titleIcon: 'time-live',
                        areEventsFetched: sportOfferDataStore.getter('areLiveEventsFetched').value,
                        sourceScreen: SelectionSourceScreen.HomeSuperLive,
                        eventCardSource: HomeEventCardSource.SuperLive,
                        class: 'e2e-super-live',
                        bettorNumberCache: bettorNumberCache.value,
                        socialProofDesignVariant: socialProofDesignVariant.value,
                    },
                    shouldShow: true,
                },
                [HomeComponent.TOP_PRICE_BOOST]: {
                    component: 'PriceBoostCarousel',
                    props: {
                        odds: priceBoostOdds.value,
                        selectedOdds: selectedOdds.value,
                        areEventsFetched: isPriceBoostCarouselEnabled.value,
                        isCardClickable: true,
                        showSeeAllButton: isPriceBoostDedicatedPagesEnabled.value,
                        showNewBadge: true,
                    },
                    events: {
                        oddClick: onPriceBoostOddClick,
                        cardClick: onPriceBoostCardClick,
                        seeAllClick: onPriceBoostSeeAllClick,
                    },
                    shouldShow: shouldRenderPriceBoostCarousel.value,
                },
                [HomeComponent.POPULAR_SUPERBETS]: {
                    component: PopularSuperbetsCarousel,
                    props: {
                        sportId: SportId.Football,
                        titleTranslationKey: translate('superOffer.popularSuperbets'),
                        titleDescription: translate(sectionSubtitleTranslationKeys.value.popularSuperbets),
                        sourceScreen: SelectionSourceScreen.HomePopularSuperbets,
                        bettorNumberCache: bettorNumberCache.value,
                        socialProofDesignVariant: socialProofDesignVariant.value,
                        class: 'e2e-popular-superbets-carousel',
                    },
                    shouldShow: arePopularSuperbetsOnHomeEnabled.value,
                },
                [HomeComponent.HOT_TOURNAMENTS]: {
                    component: HotTournamentsCarousel,
                    props: {
                        titleTranslationKey: translate('hot tournaments'),
                        titleDescription: translate(sectionSubtitleTranslationKeys.value.hotTournaments),
                    },
                    shouldShow: true,
                },
                [HomeComponent.SUPER_COTA]: {
                    component: SportOfferCarousel,
                    props: {
                        items: superKvota.value?.events,
                        primaryMarketAttribute: superKvota.value?.primaryMarketAttribute,
                        title: translate('superOffer.superKvota.name'),
                        areEventsFetched: isSuperOfferFetched.value,
                        sourceScreen: SelectionSourceScreen.HomeSuperOdds,
                        eventCardSource: HomeEventCardSource.SuperOdds,
                        titleIcon: 'commerce-odd-boost',
                        isTitleIconThemed: true,
                        class: 'e2e-super-cota',
                        bettorNumberCache: bettorNumberCache.value,
                        socialProofDesignVariant: socialProofDesignVariant.value,
                    },
                    shouldShow: showPromotedEvents && superKvota.value,
                },
                [HomeComponent.SOCIAL_VIDEOS]: {
                    component: 'SocialVideoThumbnails',
                    props: {},
                    shouldShow: isLoggedIn.value && isSocialEnabled(),
                },
                [HomeComponent.SOCIAL_DISCOVER_TICKETS]: {
                    component: 'SocialDiscoverTickets',
                    props: {},
                    shouldShow: isLoggedIn.value && isSocialEnabled(),
                },
                [HomeComponent.CASINO_GAMES]: {
                    component: 'GamingEmbeddableSection',
                    props: {
                        identifier: idOfCasinoSection.value,
                    },
                    shouldShow: isCasinoGamesOnHomePageExperimentEnabled.value,
                },
                [HomeComponent.MEBB_BANNER]: {
                    component: MEBBBanner,
                    props: {
                        sportId: SportId.Football,
                        location: MultiEventBetBuilderBannerLocation.Home,
                    },
                    shouldShow: showMEBBBanner.value,
                },
                [HomeComponent.HOME_LIVE]: {
                    component: HomeInPlay,
                    props: {
                        items: liveEvents.value,
                        totalItemsCount: sportOfferDataStore.getter('liveEventsCount').value,
                        title: translate('live events'),
                        titleDescription: translate(sectionSubtitleTranslationKeys.value.liveEvents),
                        areEventsFetched: sportOfferDataStore.getter('areLiveEventsFetched').value,
                        sourceScreen: SelectionSourceScreen.HomeInPlay,
                        eventCardSource: HomeEventCardSource.InPlay,
                        bettorNumberCache: bettorNumberCache.value,
                        socialProofDesignVariant: socialProofDesignVariant.value,
                        class: 'e2e-live-events',
                    },
                    shouldShow: true,
                },
                [HomeComponent.SOCIAL_APP_BANNER]: {
                    component: 'SocialAppBannerHome',
                    props: {},
                    shouldShow: isSocialAppEnabled(),
                },
                [HomeComponent.SUPER_EXTRA]: {
                    component: SportOfferCarousel,
                    props: {
                        items: superExtra.value?.events,
                        primaryMarketAttribute: superExtra.value?.primaryMarketAttribute,
                        title: translate('superOffer.superExtra.name'),
                        areEventsFetched: isSuperOfferFetched.value,
                        sourceScreen: SelectionSourceScreen.HomeSuperExtra,
                        eventCardSource: HomeEventCardSource.SuperExtra,
                        titleIcon: 'commerce-odd-boost',
                        bettorNumberCache: bettorNumberCache.value,
                        socialProofDesignVariant: socialProofDesignVariant.value,
                    },
                    shouldShow: showPromotedEvents && superExtra.value,
                },
                [HomeComponent.SOCIAL_NEWS]: {
                    component: 'SocialNewsCarousel',
                    props: {
                        titleLokKey: 'news',
                        titleDescription: translate(sectionSubtitleTranslationKeys.value.news),
                    },
                    shouldShow: Product.News,
                },
                [HomeComponent.SOCIAL_EXPLORE_FEED]: {
                    component: 'SocialExploreFeed',
                    props: {},
                    shouldShow: isLoggedIn.value && isSocialEnabled(),
                },
                [HomeComponent.SURVEY]: {
                    component: Survey,
                    props: {
                        surveyPageSetup,
                    },
                    shouldShow: true,
                },
                [HomeComponent.SEO_COPY]: {
                    component: SeoCopyBlockWrapper,
                    props: {},
                    shouldShow: true,
                },
                [HomeComponent.CASINO_POPUP]: {
                    component: 'PortalTarget',
                    props: {
                        name: 'casino-popup',
                    },
                    shouldShow: isCasinoGamesOnHomePageExperimentEnabled.value,
                },

            } as HomeComponentMap;
        });

        function getComponentFromMap(component: HomeComponentKey) {
            return componentsMap.value[component];
        }

        function isComponentAvailable(component: HomeComponentKey) {
            return !!getComponentFromMap(component) && getComponentFromMap(component).shouldShow;
        }

        return {
            loadingHomeContainer,
            areSportsLayoutsEnabled,
            HomeComponent,
            componentsMap,
            enabledComponents,

            title,
            SelectionSourceScreen,
            MultiEventBetBuilderBannerLocation,
            HomeEventCardSource,

            promotionBannersV2: bannerStore.getter('promotionBannersV2'),
            quickLinks,

            topTenEvents: sportOfferDataStore.getter('topTenEvents'),
            areTopTenEventsFetched: sportOfferDataStore.getter('areTopTenEventsFetched'),
            areTopTenEventsEnabled,

            showPromotedEvents,
            superKvota,
            superExtra,
            isSuperOfferFetched,

            superLiveEvents: sportOfferUiStore.getter('superLiveEvents'),
            liveEvents,
            totalLiveEventsCount: sportOfferDataStore.getter('liveEventsCount'),
            areLiveEventsFetched: sportOfferDataStore.getter('areLiveEventsFetched'),

            prematchPath: Link.Sport.PrematchOffer,
            livePath: [Link.Sport.PrematchOffer, TimeFilterSlug.Live].join('/'),

            areNewsVisible: Product.News,

            shouldRenderComponent,
            getComponentFromMap,
            isComponentAvailable,

            isMobile,
            isLoggedIn,
            isLiteMode: getLiteMode() === 'true',
            openLoginModal,
            arePopularSuperbetsOnHomeEnabled,
            isCasinoGamesOnHomePageExperimentEnabled,
            idOfCasinoSection,
            showMEBBBanner,
            SportId,
            componentRendered,
            isBelgium,
            bettorNumberCache,
            socialProofDesignVariant,

            isUserElegibleToChallenge,

            inspirationalCopyVariant,
            sectionSubtitleTranslationKeys,

            surveyPageSetup,
            homePagePriceBoostPosition,
            HomePagePriceBoostPosition,
            isPriceBoostDedicatedPagesEnabled,
            onPriceBoostCardClick,
            onPriceBoostOddClick,
            onPriceBoostSeeAllClick,
            priceBoostOdds,
            selectedOdds,
            shouldRenderPriceBoostCarousel,
        };
    },
    directives: {
        intersect: {
            inserted(el) {
                if (observer) {
                    observer.observe(el);
                }
            },
            unbind(el) {
                if (observer) {
                    observer.unobserve(el);
                }
            },
        },
    },
    components: {
        SdsSkeleton,
        QuickLinksContainer,
        SportOfferCarousel,
        HomeInPlay,
        HotTournamentsCarousel,
        MEBBBanner,
        PromotionsBannerContainer,
        GamingEmbeddableSection: getFederationComponent(() => import('gaming/EmbeddableSection')),
        SocialAppBannerHome: getFederationComponent(() => import('social/SocialAppBannerHome')),
        SocialDiscoverTickets: getFederationComponent(() => import('social/DiscoverTickets')),
        SocialNewsCarousel: getFederationComponent(() => import('social/NewsCarousel')),
        PopularSuperbetsCarousel,
        SocialVideoThumbnails: getFederationComponent(() => import('social/ExploreVideoThumbnailList')),
        SocialExploreFeed: getFederationComponent(() => import('social/ExploreTicketsHome')),
        PriceBoostCarousel: () => import('@src/federations/sportOffer/price-boost/components/PriceBoostCarousel.vue'),
        PE92InlineDepositForm,
        SeoCopyBlockWrapper,
        PE123OnboardingChallengeTracker: getFederationComponent(() => import('account/modules/onboarding/components/PE123OnboardingChallengeTracker')),
        Survey,
    },
});
